import axios from "axios";
import { message } from "antd";
import { GET_PPMC_DETAILS, UPLOAD_DOCUMENT } from "./endpoints";
import { startLoader, hideLoader } from "../Utils";
// axios.defaults.baseURL = process.env.REACT_APP_URL;
const baseUrl = process.env.REACT_APP_URL;


axios.interceptors.request.use(
  async (config) => {
    message.destroy();
    startLoader();
    config.headers["Content-type"] = "application/json; charset=UTF-8";
    config.headers["X-Client-Id"] = process.env.REACT_APP_CLIENT_ID;
     if(config?.url !== GET_PPMC_DETAILS) {
      config.headers["Bearer"] = "ASDFASDFHASDLFHASLDHF";
      config.headers["Authorization"] =
        "Bearer: 07188b28-78d5-45b9-99fa-798a12d29588";
    }
    config.url = `${baseUrl}${config?.url}`;
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  function (response) {
    hideLoader();
    return response;
  },
  async function (error) {
    hideLoader();
    return Promise.reject(error);
  }
);


export async function getApi(path, config = {}) { 
// List of allowed hosts
const allowedHosts = ['uat-online.api.manipalcigna.com', 'online.gateway.manipalcigna.com'];
// Validate the base URL
const parsedUrl = new URL(`${baseUrl}${path}`);
const hostname = parsedUrl?.hostname;
if (!allowedHosts?.includes(hostname)) {
  throw new Error(`Request to ${hostname} is not allowed`);
}
try {
    return await axios.get(path, config);
  } catch (err) {
    return err.response;
  }
}
export async function postApi(path, body, config = {}) {
  // List of allowed hosts
  const allowedHosts = ['uat-online.api.manipalcigna.com', 'online.gateway.manipalcigna.com'];
  // Validate the base URL
  const parsedUrl = new URL(`${baseUrl}${path}`);
  const hostname = parsedUrl?.hostname;
  if (!allowedHosts?.includes(hostname)) {
    throw new Error(`Request to ${hostname} is not allowed`);
  }
  try {
    return await axios.post(path, body, config);
  } catch (err) {
    return Promise.reject(err);
  }
}
export async function postUploadDocument({
  files,
  DocumentType,
  SubDocType,
  RenewalYear,
  ApplicationNumber,
  DocCategoryCd,
  DocumentCd,
  SourceName,
  DocCategoryTypeCd,
  StatusCd,
  LifeRayMemberId,
  CustomerId
}) {
  /**
      SourceName: "LR",
      DocCategoryTypeCd: "CHECKLIST",
      StatusCd: "RECEIVED",
      LifeRayMemberId: null,
      CustomerId: customerId,
   */
  let formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file.file, file.filename);
  });
  // formData.append("PolicyNumber", "");
  formData.append("DocumentClass", "ProposalDocuments");
  formData.append("DocumentType", DocumentType);
  formData.append("SubDocType", SubDocType);
  formData.append("RenewalYear", RenewalYear);
  formData.append("ApplicationNumber", ApplicationNumber);
  formData.append("DocCategoryCd", DocCategoryCd);
  formData.append("DocumentCd", DocumentCd);
  formData.append("LifeRayMemberId", LifeRayMemberId);
  formData.append("CustomerId", CustomerId);
  formData.append("StatusCd", StatusCd);
  formData.append("SourceName", SourceName);
  formData.append("DocCategoryTypeCd", DocCategoryTypeCd);

  try {
    return await axios.post(UPLOAD_DOCUMENT, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (err) {
    return err.response;
  }
}

export default axios;
